import { render, staticRenderFns } from "./project-card.html?vue&type=template&id=8a73f3fe&scoped=true&"
import script from "./project-card.js?vue&type=script&lang=js&"
export * from "./project-card.js?vue&type=script&lang=js&"
import style0 from "./project-card.scss?vue&type=style&index=0&id=8a73f3fe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a73f3fe",
  null
  
)

export default component.exports